import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'

const usd = (n: number) => n.toLocaleString('en-US', { style: 'currency', currency: 'USD' })

interface PriceChangeDialogProps {
  // VOY-551: what the page showed and what the server would charge; null while closed.
  change: { previous: number | null; current: number } | null
  onConfirm: () => void
  onDecline: () => void
}

/**
 * VOY-551: the server re-prices the order from the suppliers before charging. When that total is
 * not the one the user reviewed, nothing is charged until they see the new total and accept it.
 */
export function PriceChangeDialog({ change, onConfirm, onDecline }: PriceChangeDialogProps) {
  return (
    // Controlled with no onOpenChange: the user has to pick one of the two buttons.
    <AlertDialog open={!!change}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Your total changed</AlertDialogTitle>
          <AlertDialogDescription>
            {change?.previous != null ? (
              <>
                Prices were updated since you reviewed your order: <s>{usd(change.previous)}</s>{' '}
                <strong data-testid="price-change-current">{usd(change?.current ?? 0)}</strong>.
              </>
            ) : (
              <>
                The current total is <strong data-testid="price-change-current">{usd(change?.current ?? 0)}</strong>.
              </>
            )}{' '}
            Nothing has been charged. Continue with the new total?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onDecline}>Back to cart</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>Continue with {usd(change?.current ?? 0)}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
